<template lang="html">

  <section class="documents">
     <div class="pageHeading">
      <v-container grid-list-md pa-0>
        <v-layout row wrap>
          <v-flex >
            <h2>Trip Updates</h2>
          </v-flex>
          <v-flex xs11 md3>
            <v-autocomplete v-show="!$isParent"
                    v-model="$filterTripID"
                    :items="$structuredData.trips"
                    @change="selectedResult = null"
                    color="black"
                    hide-no-data
                    hide-selected
                    item-text="prettyName"
                    item-value="_id"
                    label="Limit To Trip ID"
                    persistent-hint
                    solo
                    clearable
                    prepend-icon="mdi-database-search"
                    return-object
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </div>


    <trip-messages v-bind:showCreate="this.isAdmin" >

    </trip-messages>

    <v-dialog
            v-model="forceRead"
            max-width="290"
    >
      <v-card>
        <v-card-title class="headline">You must acknowledge these notifications</v-card-title>

        <v-card-text>
          Have you read and agree to the trip notifications displayed here?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>


          <v-btn
                  color="primary"
                  flat="flat"
                  @click="forceRead = false"
          >
            No
          </v-btn>

          <v-btn
                  color="primary"
                  flat="flat"
                  @click="markAllRead"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </section>

</template>

<script lang="js">
    import tripMessages from '../components/TripMessages'
  export default  {
    name: 'trip-news',
    props: [],
      components: {
          tripMessages
      },
    mounted() {
        this.isAdmin = this.$userData.permissions.includes('admin')
        this.isDirector = this.$userData.permissions.includes('director')


    },
      beforeRouteLeave (to, from, next) {
          if(!this.isAdmin && !this.isDirector &&
              this.$userData.notifsRead < this.$structuredData.notifications.length && !this.acknowledged) {
              this.forceRead = true
              this.pageToRedirectToAfterAck = to.path
              next(false);
          } else {
              next(true);
          }
      },
    data() {
      return {
          pageToRedirectToAfterAck: null,
          isAdmin: false,
          acknowledged: false,
          forceRead: false,
          showHistory:true,
              tripFilter: null,

      }
    },
    methods: {
        markAllRead(){
            this.acknowledged = true
            this.forceRead = false

            let notifsList = []

            this.$structuredData.notifications.forEach((notification)=>{
                notifsList.push(notification._id)
            })

            this.$services.users.patch(this.$userData._id,
                {
                    "notifsRead":this.$structuredData.notifications.length,
                    "notifsReadList": notifsList

                })
            this.$userData.notifsRead = this.$structuredData.notifications.length
            this.$router.push(this.pageToRedirectToAfterAck)
        }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .documents {

  }
</style>
